export function pinMinimumIssue(cart) {
  const pins = (cart?.items || []).filter(item => String(item.product_id) === '8070443401388');
  if (!pins.length) return false;
  const quantity = pins.reduce((total, item) => total + Number(item.quantity), 0);
  return !Number.isSafeInteger(quantity) || quantity < 25;
}

if (typeof document !== 'undefined') {
  let config;
  try { config = JSON.parse(document.getElementById('champion-hard-minimum-config')?.textContent || 'null'); } catch {}
  if (config) {
    const selector = '[data-ct-hard-minimum]';
    const enforce = input => {
      const minimum = Number(input.dataset.ctHardMinimum);
      if (Number.isSafeInteger(minimum) && minimum > 1 && Number(input.min) < minimum) input.min = String(minimum);
    };
    const scan = root => {
      if (root.matches?.(selector)) enforce(root);
      root.querySelectorAll?.(selector).forEach(enforce);
    };
    const ready = () => {
      scan(document);
      new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'attributes') enforce(record.target);
          else record.addedNodes.forEach(scan);
        }
      }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['min']});
      document.addEventListener('submit', event => {
        const input = event.target.querySelector?.(selector);
        if (!input) return;
        enforce(input);
        if (!input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      }, true);
      const refreshCartNotice = async () => {
        if (!document.querySelector('champion-cart-quote')) return;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) return;
          const issue = pinMinimumIssue(await response.json());
          let notice = document.getElementById('champion-hard-minimum-notice');
          if (!issue) { notice?.remove(); return; }
          if (!notice) {
            notice = document.createElement('p');
            notice.id = 'champion-hard-minimum-notice';
            notice.setAttribute('role','status');
            notice.setAttribute('aria-live','polite');
            const heading = document.querySelector('main h1');
            heading?.insertAdjacentElement('afterend',notice);
          }
          notice.textContent = config.message;
        } catch {}
      };
      let refreshTimer;
      const schedule = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCartNotice,200); };
      document.addEventListener('cart:refresh',schedule);
      document.addEventListener('cart:updated',schedule);
      document.addEventListener('change',event => { if(event.target.matches?.('.quantity-selector__value[data-line]')) schedule(); });
      refreshCartNotice();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready,{once:true});
    else ready();
  }
}
